import axios from 'axios';
import { EDIExportRequest } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

/**
 * Service for EDI (Échange de Données Informatisé) export operations.
 * Provides XML export functionality for Moroccan accounting requirements.
 */
class EDIService {
    /**
     * Export EDI data as XML file.
     * Downloads the generated XML file automatically.
     * 
     * @param request Export request containing company IDs, date range, and export types
     */
    async exportEDI(request: EDIExportRequest): Promise<void> {
        const token = localStorage.getItem('token');

        try {
            const response = await axios.post(`${API_BASE_URL}/edi/export`, request, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                responseType: 'blob',
            });

            // Generate filename from dates
            const startDateStr = request.startDate.replace(/-/g, '');
            const endDateStr = request.endDate.replace(/-/g, '');
            const todayStr = new Date().toISOString().split('T')[0].replace(/-/g, '');
            const filename = `EDI_Export_${startDateStr}_${endDateStr}_${todayStr}.xml`;

            // Create download link
            const blob = new Blob([response.data], { type: 'application/xml' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            link.style.display = 'none';

            // Trigger download
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Cleanup
            window.URL.revokeObjectURL(url);

            console.log(`EDI export downloaded: ${filename}`);
        } catch (error) {
            console.error('EDI export failed:', error);
            throw error;
        }
    }
}

export const ediService = new EDIService();
